export default "__VITE_ASSET__70141109__"